import { toast } from "sonner";
import type { StatusNaBase, TipoNaBase } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

const ACOES: { status: StatusNaBase; rotulo: string }[] = [
  { status: "PUBLICADO", rotulo: "Publicar" },
  { status: "RASCUNHO", rotulo: "Voltar a rascunho" },
  { status: "ARQUIVADO", rotulo: "Arquivar" },
];

/** Ações em lote sobre os itens marcados — fixa embaixo enquanto há seleção. */
export function BarraDeSelecao({ tipo, ids, onLimpar }: { tipo: TipoNaBase; ids: string[]; onLimpar: () => void }) {
  const utils = trpc.useUtils();
  const mudar = trpc.admin.base.mudarStatus.useMutation({
    onSuccess: ({ alterados }) => {
      utils.admin.base.listar.invalidate();
      utils.admin.base.resumo.invalidate();
      utils.admin.base.opcoes.invalidate();
      toast.success(`${alterados} ${alterados === 1 ? "item alterado" : "itens alterados"}.`);
      onLimpar();
    },
    onError: (e) => toast.error(e.message || "Não foi possível mudar o status."),
  });
  if (ids.length === 0) return null;
  return (
    <div className="sticky bottom-4 z-10 mx-auto flex w-fit flex-wrap items-center gap-2 rounded-xl border border-zinc-200 bg-white px-4 py-2.5 shadow-xl">
      <span className="text-sm font-semibold text-admin-900">
        {ids.length} {ids.length === 1 ? "marcado" : "marcados"}
      </span>
      {ACOES.map((a) => (
        <button
          key={a.status}
          type="button"
          disabled={mudar.isPending}
          onClick={() => mudar.mutate({ tipo, ids, status: a.status })}
          className={
            a.status === "PUBLICADO"
              ? "h-8 rounded-md bg-admin-900 px-3 text-sm font-semibold text-white hover:bg-admin-700 disabled:opacity-50"
              : "h-8 rounded-md border border-admin-200 px-3 text-sm font-medium text-admin-900 hover:bg-admin-50 disabled:opacity-50"
          }
        >
          {a.rotulo}
        </button>
      ))}
      <button type="button" onClick={onLimpar} className="h-8 px-2 text-sm text-admin-700 hover:text-admin-900">
        Limpar
      </button>
    </div>
  );
}
